// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalHeader_header__WkBke","back":"ModalHeader_back__7C3rj","close":"ModalHeader_close__f2XZZ"};